const cookieDomain = () => {
    const hostname = document.location.hostname;

    if (hostname.endsWith('.perceptionhealth.com')) {
        return 'perceptionhealth.com';
    } else if (hostname.endsWith('mi.huronconsultinggroup.com')) {
        return 'mi.huronconsultinggroup.com';
    } else if (hostname === 'localhost') {
        return 'localhost';
    } else {
        console.error('Error setting cookie domain');
    }

    return;
}

const cookieExpiration = () => {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    return expirationDate;
}

export const cookieAttributes = () => {
    return {
        expires: cookieExpiration(),
        domain: cookieDomain(),
        sameSite: 'lax',
    };
}